import type {Component, Editor} from 'grapesjs';
import type {ImageData} from '@Libraries/add-media-library';
import {EMAIL_MAKER_PROPS} from '@EmailMakerReact/email-maker-react.constants';
import {setImageSrc, setImageLoading} from '@EmailMakerReact/lib/email-maker-media-library';
import {openMediaModal} from '@EmailMakerReact/lib/email-maker-media-modals-library';
import {setComponentStyle} from '@EmailMakerReact/lib/email-maker-component-style-library';
import type {UploadButtonDescriptor} from './upload-button-control.types';
import {VIDEO_MEDIA_EXTENSIONS} from './upload-button-control.types';

export const backgroundMediaDescriptor: UploadButtonDescriptor = {
  labelKey: 'pmwjs_background_media',
  property: 'background-image',

  onUpload(editor: Editor, component: Component, onMediaSelected: (url: string) => void): void {
    openMediaModal(editor, {
      onStartAddSelected: (): void => {
        setImageLoading(editor, {component, loading: true, text: window.i18next.t('pmwjs_loading')});
      },
      onAddSelected: (mediaItems: ImageData[]): void => {
        if (!mediaItems[0]) {
          return;
        }

        const mediaType = VIDEO_MEDIA_EXTENSIONS.includes(mediaItems[0].extension ?? '') ? 'video' : 'image';

        component.set(EMAIL_MAKER_PROPS.MEDIA_TYPE, mediaType);
        component.set(EMAIL_MAKER_PROPS.HAS_BACKGROUND_MEDIA, true);

        void setImageSrc(editor, {
          callback: onMediaSelected,
          isBackground: true,
          component,
          source: mediaItems[0].source,
          hashedFilename: mediaItems[0].hashedFilename,
        });
      },
    });
  },

  onClear(editor: Editor, component: Component): void {
    component.set(EMAIL_MAKER_PROPS.MEDIA_TYPE, undefined);
    component.set(EMAIL_MAKER_PROPS.HAS_BACKGROUND_MEDIA, false);

    setComponentStyle(editor, {property: 'background-image', value: '', component});
    component.removeAttributes(['background']);
  },
};
